function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.512 11.81v35.236l-1.819 1.815H22.695c-.714-.708-1.11-1.107-1.82-1.815V5.55c.71-.708 1.106-1.108 1.82-1.816h24.726l8.091 8.074z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#document_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.66 1.52h39.067v49.556H18.661V1.521z",
  fill: "#FFCE32"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.511 26.46v20.587l-1.82 1.816H33.06L55.511 26.46z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#document_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.845 24.246h26.88v26.831h-26.88v-26.83z",
  fill: "#D8B87A"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.512 11.81h-8.09V3.734l8.09 8.074z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#document_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.206 1.52h12.521v12.504h-12.52V1.52z",
  fill: "#F8FBCF"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.36 17.77v2.657H28.79V17.77h20.57zM49.36 21.977v2.658H28.79v-2.658h20.57zM49.36 26.186v2.657H28.79v-2.657h20.57zM49.36 30.393v2.657H28.79v-2.657h20.57zM49.36 34.6v2.658H28.79v-2.657h20.57z",
  fill: "#003035"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.725 21.668l2.173 2.177-12.688 12.66-2.172-2.178 12.687-12.659zM44.538 45.86l2.173 2.177-11.245 11.22-2.172-2.178 11.244-11.22zM24.6 42.042l2.172 2.177L9.5 61.453l-2.172-2.178 17.271-17.233z",
  fill: "#23E5DB"
});

const SvgDocument = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "document_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 20,
  y: 3,
  width: 36,
  height: 46
}, _ref), _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "document_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 33,
  y: 26,
  width: 23,
  height: 23
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "document_svg__c",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 47,
  y: 3,
  width: 9,
  height: 9
}, _ref5), _ref6, _ref7, _ref8);

export default SvgDocument;